import "./index.scss";
import CloseImg from "../../../assets/images/close.svg";

import React from "react";

const CloseButton = ({ closeAction, classes, classesButton }) => {
  return (
    <div
      className={`close-button ${classesButton && classesButton}`}
      onClick={closeAction}
    >
      <img
        src={CloseImg}
        alt="close"
        className={`close-button__icon ${classes && classes}`}
      />
    </div>
  );
};

export default CloseButton;
